
import Vue from 'vue';
import { isWeiXin } from '@/common/ts/common';
import { getReaderConfig } from './api';

export default Vue.extend({
  data() {
    const routeTitle = String(
      (this.$route.meta && this.$route.meta.title) || '',
    );

    return {
      shareTitle: routeTitle,
      shareSubtitle: routeTitle,
    };
  },
  watch: {
    $route: {
      immediate: true,
      async handler() {
        try {
          const response = await getReaderConfig();
          const config = response.data;
          this.shareTitle = config.title || this.shareTitle;
          this.shareSubtitle =
            config.subtitle || config.title || this.shareTitle;
        } catch (error) {
          const fallbackTitle = String(
            (this.$route.meta && this.$route.meta.title) || '',
          );
          this.shareTitle = fallbackTitle || this.shareTitle;
          this.shareSubtitle = fallbackTitle || this.shareSubtitle;
        }

        this.$appShareInfo({
          title: this.shareTitle,
          url: location.href,
          subtitle: this.shareSubtitle,
          classId: -1,
          id: -1,
          type: 3,
        });

        if (isWeiXin()) {
          this.$wxShareInfo({
            title: this.shareTitle,
            subtitle: this.shareSubtitle,
          });
        }
      },
    },
  },
});
